<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { getFragmentConfigOr } from "~/components/fragment-sets/basic_component/util";
  import Collapse from "~/components/fragment-sets/common/Collapse.svelte";
  import StoreSocialMediaNRestaurants from "./StoreSocialMediaNRestaurants.svelte";
  import StoreContactInfo from "./StoreContactInfo.svelte";
  import StoreOpHours from "./StoreOpHours.svelte";

  export let request_store_key: StoresKey;
  export let fragment: Fragment;
  
  const { store, T, reverse_router } = getStoresContext(request_store_key);

  let hrefMap: string;

  $: t = $T;

  $: if($store) {
    hrefMap = `${$reverse_router.findPurposeRoute('floor map')}?store=${$store.id}`;
  }

  $: innerWidth = 0;
  $: isOpen = innerWidth < 768 || false;

  const lunchListPageUrl = getFragmentConfigOr("lunchListURL", fragment, "/lounaslistat");
  $: foodoraUrl = $store?.restaurantInfo?.foodoraUrl;
  $: woltUrl = $store?.restaurantInfo?.woltUrl;
</script>

<svelte:window bind:innerWidth />
{#if $store}
  <div class="px-0 pt-1 mb-5 d-none d-lg-block store-info">
    <div class="logo-wrapper">
      {#if $store.logoURL}
        <img src={$store.logoURL} alt={$store.name} />
      {:else}
        <b>{$store.name}</b>
      {/if}
    </div>
    <div class="opening-hours-wrapper">
      <div class="opening-hours-title">{t`opening`}</div>   
      <StoreOpHours {request_store_key}/>
    </div>
    <StoreContactInfo {request_store_key}/>
    {#if $store.giftCardEnabled}
      <div class="right-inner-wrapper mt-3 mt-lg-0 mx-3 mx-lg-0 giftcard-wrapper">
        <div class="right-inner-title">{t`we-accept`}</div>
        <div class="giftcard">
          <img width="30px" src="/theme/malloftripla2024/images/lahjakortti.png" alt="lahjakortti" />
          {t`gift-card`}
        </div>
      </div>
    {/if}

    <a href={hrefMap}>
      <div class="show-store-on-map right-inner-wrapper purple-button fw-normal">
        <i class="bi bi-chevron-right" />
        {t`show-store-on-map`}
      </div>
    </a>
    {#if $store.hasLunchMenu}
      <a href={lunchListPageUrl}>
        <div class="show-store-on-map right-inner-wrapper purple-button fw-normal">
          <i class="bi bi-chevron-right" />
          {t`lunch-list`}
        </div>
      </a>
    {/if}
    
    {#if foodoraUrl || woltUrl}
      <div
        class="px-5 align-items-center mt-5 d-flex justify-lg-content-between justify-content-center"
      >
        {#if foodoraUrl}
          <a
            href={foodoraUrl}
            class="text-center"
            target="_blank"
            rel="noreferrer"
          >
            <img src="/theme/malloftripla2024/images/Foodora-logo.png" alt="Foodora" class="w-75" />
          </a>
        {/if}
        {#if woltUrl}
          <a href={woltUrl} class="text-center" target="_blank" rel="noreferrer">
            <img src="/theme/malloftripla2024/images/Wolt-logo.png" alt="Foodora" class="wolt" />
          </a>
        {/if}
      </div>
    {/if}
    <div class="pb-5"></div>
    <StoreSocialMediaNRestaurants store={$store}/>
  </div>

  <!-- Mobile view -->
  <div class="col-12 d-lg-none px-3">
    <h1 class="store-name font-reliable text-center">{$store.name}</h1>
    <div class="logo-wrapper">
      {#if $store.logoURL}
        <img src={$store.logoURL} alt={$store.name} />
      {:else}
        <b>{$store.name}</b>
      {/if}
    </div> 
    <div class="text-left">
      <StoreContactInfo {request_store_key}/>
    </div>
    
  <Collapse open_by_default={isOpen}>  
    <div slot="open" class="store-info-mobile">
      {t`opening`}
      <i class="bi bi-dash-lg" />
    </div>
    <div  slot="close" class="store-info-mobile">
      {t`opening`}
      <i class="bi bi-plus-lg" />
    </div>
    <div class="text-left">
      <StoreOpHours {request_store_key}/>
    </div>
  </Collapse>      
  <Collapse>
    <div slot="open" class="store-info-mobile">
      {t`description`}
      <i class="bi bi-dash-lg" />
    </div>
    <div slot="close" class="store-info-mobile">
      {t`description`}
      <i class="bi bi-plus-lg" />
    </div>
    <div class="text-left">
      <p class="mt-3 mt-lg-0 mx-3 mx-lg-0 fw-bold">{$store.descriptionTitle}</p>
      <p class="mt-3 mt-lg-0 mx-3 mx-lg-0">
        {@html $store.description.replace(/(\r\n|\n\r|\r|\n)/g, '<br>')}
      </p>
      {#if $store.images?.length == 2}
        <img src={$store.images?.[1]} alt={$store.descriptionTitle} class="w-100 my-lg-5 my-4" />
      {/if}
    </div>
  </Collapse>
    <br />
    {#if $store.giftCardEnabled}
    <div class="right-inner-wrapper mt-3 mt-lg-0 mx-3 mx-lg-0 giftcard-wrapper">
      <div class="right-inner-title">{t`we-accept`}</div>
      <div class="giftcard">
        <img width="30px" src="/theme/malloftripla2024/images/lahjakortti.png" alt="lahjakortti" />
        {t`gift-card`}
      </div>
    </div>
  {/if}
  <br />
  <a href={hrefMap}>
    <div class="show-store-on-map right-inner-wrapper purple-button fw-normal">
      <i class="bi bi-chevron-right" />
      {t`show-store-on-map`}
    </div>
  </a>
  {#if $store.hasLunchMenu}
    <a href={lunchListPageUrl}>
      <div class="show-store-on-map right-inner-wrapper purple-button fw-normal">
        <i class="bi bi-chevron-right" />
        {t`lunch-list`}
      </div>
    </a>
  {/if}
  {#if foodoraUrl || woltUrl}
    <div
      class="px-5 align-items-center mt-5 mb-5 d-flex justify-lg-content-between justify-content-center"
    >
      {#if foodoraUrl}
        <a
          href={foodoraUrl}
          class="text-center"
          target="_blank"
          rel="noreferrer"
        >
          <img src="/malloftripla2024/images/foodora.png" alt="Foodora-logo" class="w-75" />
        </a>
      {/if}
      {#if woltUrl}
        <a href={woltUrl} class="text-center" target="_blank" rel="noreferrer">
          <img src="/malloftripla2024/images/wolt.png" alt="Foodora-logo" class="wolt" />
        </a>
      {/if}
    </div>
  {/if}
  <StoreSocialMediaNRestaurants store={$store}/>
  </div> 
{/if}

<style lang="scss">
  .store-info {
    width: 100%;
    background-color: var(--color-accent-secondary-light);
  }
  .opening-hours-title {
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
  .logo-wrapper {
    position: relative;
    width: 35%;
    border: 1px solid var(--color-accent-secondary);
    margin: 15px auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    margin-bottom: 40px;
    @media screen and (min-width: 992px) {
      width: 80%;
      margin-bottom: 60px;
    }
    img {
      position: absolute;
      max-width: 80%;
      max-height: 80%;
    }
  }
  .logo-wrapper:after {
    content: '';
    display: block;
    padding-bottom: 100%;
  }
  .opening-hours-wrapper {
    text-align: center;
    margin-bottom: 60px;
  }
  .giftcard-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    .giftcard {
      background-color: var(--color-accent-primary);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      width: 100px;
      flex-direction: column;
      aspect-ratio: 1/1;
      color: #fff;
      font-size: 14px;
      font-family: 'Archivo-Bold', sans-serif;
    }
    img {
      width: 30px;
      margin-bottom: 5px;
    }
  }
  .show-store-on-map {
    display: flex;
    align-items: center;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    margin-bottom: 20px !important;
    text-align: center;
    padding:5px 10px !important;
    font-weight: normal;
    @media screen and (min-width: 992px) {
      width: 75%;
    }
    &:hover {
      text-decoration: none;
    }
    i {
      margin-right: 10px;
    }
  }

  .right-inner-wrapper {
      text-align: center;
      margin-bottom: 60px;
      padding: 0 20%;
      @media screen and (max-width: 991px) {
        text-align: left;
        padding: 0;
      }
      a {
        text-decoration: none;
        word-wrap: break-word;
      }
      .right-inner-title {
        font-size: 1.2rem;
        margin-bottom: 10px;
      }
  }
  // Mobile styles

  .store-info-mobile {
    background-color: var(--color-accent-secondary-light);
    color: #000;
    align-items: center;
    padding: 10px 20px;
    justify-content: space-between;
    display: flex;
    margin-bottom: 5px;
    i {
      color: var(--color-accent-primary-text);
      font-weight: 900 !important;
    }
  }

  :global(.store-own .breadcrumbs) {
    margin-top: 0 !important;
    @media screen and (max-width: 991px) {
      padding: 0 15px;
      max-width: 990px;
    }
  }

  .wolt {
    width: 50%;
    @media screen and (min-width: 992px) {
      width: 75%;
    }
  }
</style>
  